module.exports = "/img/_/_/_/assets/images/creeper/book/rare//7.jpg?f97d6a58c865545e0fc1580ede32fa37";